import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header.jsx';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { blogCategories, blogPosts } from '../data/posts.js';

const cardStyle = {
  borderRadius: '16px',
  border: '1px solid #e2e8f0',
  boxShadow: 'none',
  backgroundColor: '#ffffff',
};

export const Posts = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
      <Header />

      <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
        <Stack spacing={3}>
          <Card sx={cardStyle}>
            <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
              <Stack spacing={1.5}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
                  Software Development Blog
                </Typography>
                <Typography sx={{ color: '#475569', lineHeight: 1.8 }}>
                  My notes, observations and thoughts about software development and coding in general. I mostly write about incidents, post-mortems and best practices that I find interesting and useful.
                </Typography>
                <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                  {blogCategories.map((category) => (
                    <Chip key={category} label={category} size="small" sx={{ backgroundColor: '#f1f5f9', color: '#334155', fontWeight: 600 }} />
                  ))}
                </Stack>
              </Stack>
            </CardContent>
          </Card>

          <Grid container spacing={2}>
            {blogPosts.map((post) => (
              <Grid item xs={12} key={post.slug}>
                <Card sx={cardStyle}>
                  <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
                    <Stack spacing={1.2}>
                      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
                        <Chip label={post.category} size="small" sx={{ backgroundColor: '#e2e8f0', color: '#1e293b', fontWeight: 700 }} />
                        <Chip label={post.readTime} size="small" sx={{ backgroundColor: '#f8fafc', color: '#475569', fontWeight: 700 }} />
                      </Stack>
                      <Typography sx={{ color: '#64748b', fontSize: '0.9rem' }}>{post.date}</Typography>
                      <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.3 }}>
                        {post.title}
                      </Typography>
                      <Typography sx={{ color: '#475569', lineHeight: 1.8 }}>{post.excerpt}</Typography>
                      <Button
                        component={Link}
                        to={`/posts/${post.slug}`}
                        variant="contained"
                        sx={{
                          mt: 0.5,
                          width: 'fit-content',
                          textTransform: 'none',
                          borderRadius: '999px',
                          backgroundColor: '#0f172a',
                          '&:hover': { backgroundColor: '#1e293b' },
                        }}
                      >
                        Read more
                      </Button>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Container>
    </Box>
  );
};

export default Posts;
